import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-custom-select",
  templateUrl: "app-custom-select.component.html",
  styleUrls: ["app-custom-select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppCustomSelectComponent),
      multi: true,
    }
  ],
  host: {
    "(document:keydown)": "handleKeyboardEvents($event)",
  },
})
export class AppCustomSelectComponent implements ControlValueAccessor {
  @Input() options: any;
  @Input() title: string;
  @Input() displayProp: string;
  @Output() currentValueChange = new EventEmitter();

  disabled = false;
  private onTouched!: Function;
  private onChanged!: Function;

  public currentValue = {};
  public optionValue = [];
  public dropdownOpen: boolean = false;
  public get dropdownElement(): Element {
    return this.elem.nativeElement.querySelector(".dropdown-list");
  }

  private currentIndex = -1;

  constructor(private elem: ElementRef) {}


  writeValue(obj: any): void {
    this.currentValue = obj;
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    //this.options[0] = this.title;
    this.currentValue = {
      bankNm: this.title,
    };
    const _title = { bankNm: this.title };

    this.options.unshift(_title);
  }

  handleKeyboardEvents($event: KeyboardEvent) {
    if (this.dropdownOpen) {
      $event.preventDefault();
    } else {
      return;
    }
    if ($event.code === "ArrowUp") {
      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      } else if (this.currentIndex > 0) {
        this.currentIndex--;
      }
      this.elem.nativeElement
        .querySelectorAll("li")
        .item(this.currentIndex)
        .focus();
    } else if ($event.code === "ArrowDown") {
      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      } else if (this.currentIndex < this.options.length - 1) {
        this.currentIndex++;
      }
      this.elem.nativeElement
        .querySelectorAll("li")
        .item(this.currentIndex)
        .focus();
    } else if (
      ($event.code === "Enter" || $event.code === "NumpadEnter") &&
      this.currentIndex >= 0
    ) {
      this.selectByIndex(this.currentIndex);
    } else if ($event.code === "Escape") {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.dropdownElement.setAttribute("aria-expanded", "false");
    this.currentIndex = -1;
    this.dropdownOpen = false;
  }

  selectByIndex(i: number) {
    let value = this.options[i];
    this.select(value);
  }

  select(value) {
    this.currentValue = value;
    this.closeDropdown();
    this.currentValueChange.emit(this.currentValue);
    this.onTouched();
    this.onChanged(value);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    this.dropdownElement.setAttribute(
      "aria-expanded",
      this.dropdownOpen ? "true" : "false"
    );
  }
}
